enum FeatureFlagKeysEnum {
  email = 'email',
  anonymous = 'anonymous',
  tenantId = 'tenantId',
  fqTenantId = 'fqTenantId',
  portalName = 'portalName',
  idpId = 'idpId'
}

export default FeatureFlagKeysEnum;
